import React, { useEffect } from "react";

import { Toaster } from "react-hot-toast";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store from "./redux/store";
import { RouterProvider } from "react-router-dom";
import router from "./routes/router/Router";
import { onAppStart } from "./onAppStart";

function App() {
  useEffect(() => {
    onAppStart();
  }, []);

  return (
    <Provider store={store.store}>
      <PersistGate persistor={store.persistor} loading={null}>
        <RouterProvider router={router} />
        <Toaster />
      </PersistGate>
    </Provider>
  );
}

export default App;
